import { Build } from "@stencil/core";
export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["MOBILE"] = "MOBILE";
    Breakpoints["TABLET"] = "TABLET";
    Breakpoints["DESKTOP"] = "DESKTOP";
    Breakpoints["LARGE_DESKTOP"] = "LARGE_DESKTOP";
    Breakpoints["EXTRA_LARGE_DESKTOP"] = "EXTRA_LARGE_DESKTOP";
})(Breakpoints || (Breakpoints = {}));
class MobileUtilityService {
    constructor() {
        this.breakpoint = Breakpoints.MOBILE;
        this.viewportChangedListeners = [];
        this.registerMatchMediaListeners();
    }
    addViewportChangedListener(listener) {
        this.viewportChangedListeners.push(listener);
        this.callListeners([listener]);
        return () => {
            this.viewportChangedListeners = this.viewportChangedListeners.filter(_listener => _listener !== listener);
        };
    }
    removeViewportChangedListener(listener) {
        this.viewportChangedListeners = this.viewportChangedListeners.filter(_listener => _listener !== listener);
    }
    callListeners(listeners) {
        listeners.forEach((listener) => listener.apply(null, [this.breakpoint]));
    }
    registerMatchMediaListeners() {
        const mediaQueries = {
            [Breakpoints.MOBILE]: '(max-width: 767px)',
            [Breakpoints.TABLET]: '(min-width: 768px) and (max-width: 991px)',
            [Breakpoints.DESKTOP]: '(min-width: 992px) and (max-width: 1199px)',
            [Breakpoints.LARGE_DESKTOP]: '(min-width: 1200px) and (max-width: 1399px)',
            [Breakpoints.EXTRA_LARGE_DESKTOP]: '(min-width: 1400px)',
        };
        Object.keys(mediaQueries).forEach((breakpoint) => {
            const matchMedia = window.matchMedia(mediaQueries[breakpoint]);
            if (!Build.isBrowser) {
                return;
            }
            matchMedia.addEventListener('change', (mediaQueryListEvent) => {
                if (mediaQueryListEvent.matches) {
                    this.breakpoint = breakpoint;
                    this.callListeners(this.viewportChangedListeners);
                }
            });
            if (matchMedia.matches) {
                this.breakpoint = breakpoint;
            }
        });
    }
}
export const MobileUtility = new MobileUtilityService();
//# sourceMappingURL=mobile-utility.js.map
